import { useContext } from "react";
import DropdownCore from "./components/DropdownCore";
import DropdownItem from "./components/DropdownItem";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit2 } from "react-icons/fi";
import modalContext from "../../../dataManager/context/modalContext";

const CategoryDropdown = ({ categoryId }) => {
  //context variables
  const { handleOpenModal } = useContext(modalContext);

  return (
    <DropdownCore>
      <DropdownItem
        icon={<FiEdit2 size={17} />}
        title="Modifier"
        onClick={() =>
          handleOpenModal("EDIT_CATEGORY", "Modifier cette catégorie", {
            categoryId,
          })
        }
      />
      <DropdownItem
        icon={<AiOutlineDelete size={18} />}
        title="Supprimer"
        onClick={() =>
          handleOpenModal("DELETE_CATEGORY", "Supprimer cette catégorie", {
            categoryId,
          })
        }
      />
    </DropdownCore>
  );
};

export default CategoryDropdown;
